/**
 * Names one end of a range for display, ex "Price minimum". A range that
 * carries no label falls back to the bound on its own, "Minimum", so the name
 * still reads as a sentence opener.
 */
export const toBoundLabel = (
  bound: 'Maximum' | 'Minimum',
  label?: string
): string => (label ? `${label} ${bound.toLowerCase()}` : bound);
